import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe, PercentPipe} from "@angular/common";

@Component({
  selector: 'pipelines-panel-credit-outlets',
  imports: [
    DatePipe,
    PercentPipe
  ],
  templateUrl: './pipelines-panel-credit-outlets.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-credit-outlets.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelCreditOutletsComponent implements OnInit{
  @Input() detail:any;
  public expanded:boolean

  ngOnInit() {
  }


  public toggleExpanded(){
    this.expanded = !this.expanded
  }
}
